import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-4" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSutron',
  setup(__props) {

const SutronInsMonitor = defineAsyncComponent(() => import("@/components/theme/stations/sutron/SutronInsMonitor.vue"))
const SutronTempCard = defineAsyncComponent(() => import("@/components/theme/stations/sutron/SutronTempCard.vue"))
const SutronStatistics = defineAsyncComponent(() => import("@/components/theme/stations/sutron/SutronStatistics.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SutronInsMonitor)),
      _createVNode(_unref(SutronStatistics)),
      _createVNode(_unref(SutronTempCard))
    ])
  ]))
}
}

})